import { Component, Input, OnDestroy, OnInit } from '@angular/core'

import { Subscription } from 'rxjs'
import { ComputedRecord } from '../../../../models/states-computed.models'
import { AlgorithmMode, MachineState } from '../../../../models/states.models'
import { TouaregControlStateParamsService } from '../../../../services/touareg-control-state-params.service'
import { TouaregControlStateMachineService } from '../../../../services/touareg-control-state-machine.service'
import { TouaregControlStateLayoutComponent } from '../../layout/touareg-control-state-layout.component';
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-state-pick',
  templateUrl: './touareg-control-state-pick.component.html',
  styleUrls: ['./touareg-control-state-pick.component.scss'],
  imports: [TouaregControlStateLayoutComponent, Samv2Module],
})
export class TouaregControlStatePickComponent implements OnDestroy {
  @Input()
  state!: MachineState

  public modeFetching!: boolean
  public modeLockFetching!: boolean

  public get isLockMode(): boolean {
    return this.state?.algorithm_mode === AlgorithmMode.manual_locked
  }

  public get isManualMode(): boolean {
    return this.state?.algorithm_mode === AlgorithmMode.manual
  }

  public get isAutoMode(): boolean {
    return this.state?.algorithm_mode === AlgorithmMode.auto
  }

  private _isActionDoneSubs$!: Subscription

  constructor(private _stateMachine: TouaregControlStateMachineService) {}

  public onSuggestion(tags: ComputedRecord[]) {
    this._stateMachine.actionRejectTag(tags)
  }

  public onSelection(tags: ComputedRecord[]) {
    this._stateMachine.actionPickTag(tags)
  }

  public deSelection(tags: ComputedRecord[]) {
    this._stateMachine.actionRejectTag(tags)
  }

  public onManualAdd(tags: any[]) {
    if (tags?.length) {
      this._stateMachine.actionManualPickTag(tags)
    }
  }

  setManualMode(e: MouseEvent) {
    let state$
    this.modeFetching = true
    this.modeLockFetching = false
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
    state$ = this._stateMachine.setModeManual()
    this._isActionDoneSubs$ = state$.subscribe((s) => (this.modeFetching = !s))
  }

  setAutoMode(e: MouseEvent) {
    let state$
    this.modeFetching = true
    this.modeLockFetching = false
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
    state$ = this._stateMachine.setModeAuto()
    this._isActionDoneSubs$ = state$.subscribe((s) => (this.modeFetching = !s))
  }

  setLockMode(e: MouseEvent) {
    let state$
    this.modeFetching = false
    this.modeLockFetching = true
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
    state$ = this._stateMachine.setModeLock()
    this._isActionDoneSubs$ = state$.subscribe((s) => {
      this.modeLockFetching = !s
    })
  }

  setExitLockMode(e: MouseEvent) {
    let state$
    this.modeFetching = false
    this.modeLockFetching = true
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
    state$ = this._stateMachine.setModeAuto()
    this._isActionDoneSubs$ = state$.subscribe(
      (s) => (this.modeLockFetching = !s)
    )
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
  }
}
